import { getSlots } from "@/http/clubsApi";
import { getSlotsQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetSlotsQuery = (clubId: string, userToken: string) => {
  return useQuery({
    queryKey: [...getSlotsQueryKey(), clubId],
    queryFn: () => getSlots(clubId, userToken),
    enabled: !!clubId && !!userToken,
  });
};
